var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 81,
    viewBox: "0 0 94 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.656 64.9407L74.28 72.8527C70.048 78.0047 63.976 80.7647 56.892 80.7647C47.324 80.7647 40.608 77.2687 30.672 66.7807C13.008 64.5727 0.588013 51.2327 0.588013 33.7527C0.588013 14.6167 15.492 0.44873 35.824 0.44873C56.064 0.44873 71.06 14.5247 71.06 33.7527C71.06 48.8407 61.768 60.8007 48.06 65.2167C51.188 68.5287 53.948 69.7247 57.168 69.7247C61.124 69.7247 64.62 68.1607 67.656 64.9407ZM15.676 33.7527C15.676 45.9887 24.324 54.3607 35.824 54.3607C47.324 54.3607 55.972 45.9887 55.972 33.7527C55.972 21.5167 47.324 13.1447 35.824 13.1447C24.324 13.1447 15.676 21.5167 15.676 33.7527Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8801 66.6887C79.9121 66.6887 75.9561 62.9167 75.9561 57.6727C75.9561 52.3367 79.9121 48.8407 84.8801 48.8407C89.8481 48.8407 93.8041 52.3367 93.8041 57.6727C93.8041 62.9167 89.8481 66.6887 84.8801 66.6887Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqq);
export default __webpack_public_path__ + "static/media/faqq.8bd230a264bacfb7eb7bd833b110b540.svg";
export { ForwardRef as ReactComponent };